import React from 'react';
import logo from '../../assets/full_logo_footer.png';
import './Footer.scss';
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { useTranslation } from '../../i18n/useTranslation';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';

const Footer = () => {
    const { t } = useTranslation();

    const footerContacts = [
        {
            title: t('footer.phoneNumber'),
            info: '079 260 2666',
            icon: call
        },
        {
            title: t('footer.openHour'),
            info: '09:00 AM - 18:00 PM',
            icon: time
        },
        {
            title: t('footer.clinicAddress'),
            info: t('appointment.location'),
            icon: location
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <img src={logo} alt="logo" />
                        </div>
                        <p>{t('footer.description')}</p>

                        <div className="social-logo">
                            <p>{t('footer.followUs')}</p>
                            <ul>
                                <li><a href="https://www.facebook.com/profile.php?id=61559909330950&is_tour_dismissed"><FaFacebookF/></a></li>
                                <li><a href="https://www.instagram.com/alsaketdental/"><FaInstagram/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>{t('footer.contactInformation')}</p>

                            {
                                footerContacts.map((footerContact, index) => {
                                    return  <div key={index} className="contact-list">
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt="call" />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5 className={footerContact.title === t('footer.phoneNumber') ? 'phone-number' : ''}>{footerContact.info}</h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; {t('footer.copyright')}</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
